export default __webpack_public_path__ + "static/media/layout04.666e6c54.png";